import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, XCircle, Loader2, AlertTriangle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

/** Unfinished Stripe payment: pay again (fresh checkout) or cancel the pending registration. */
export default function PendingPaymentActions({ registration, eventId, onCancelled, compact = false }) {
  const [busy, setBusy] = useState(null);
  const pay = async () => {
    setBusy("pay");
    try {
      const { data } = await api.post(`/event-registrations/${registration.id}/regenerate-checkout`, { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Impossible de créer le lien de paiement"); setBusy(null); }
  };
  const cancel = async () => {
    if (!window.confirm("Annuler cette inscription en attente de paiement ? Vous pourrez vous réinscrire avec un autre billet.")) return;
    setBusy("cancel");
    try { await api.delete(`/my/event-registration/${eventId}`); toast.success("Inscription en attente annulée"); window.dispatchEvent(new Event("event-spaces:refresh")); onCancelled?.(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Erreur"); }
    finally { setBusy(null); }
  };
  const amount = `${Number(registration.price || 0).toLocaleString("fr-FR")} ${(registration.currency || "eur").toUpperCase()}`;
  return (
    <div className={`rounded-2xl border border-amber-200 bg-amber-50 ${compact ? "p-3" : "p-4"}`} data-testid="pending-payment-block">
      <div className="flex items-start gap-2 text-sm text-amber-900">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <div><strong>Paiement en attente</strong> — {registration.ticket_name ? `${registration.ticket_name} · ` : ""}{amount}. Votre place n'est confirmée qu'après paiement. Sans paiement sous 24 h, l'inscription est automatiquement annulée.</div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={pay} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-full bg-wine-500 px-4 py-2 text-xs font-bold text-white hover:bg-wine-600 disabled:opacity-60" data-testid="pending-pay-now">
          {busy === "pay" ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />}Payer maintenant
        </button>
        <button onClick={cancel} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-full border border-neutral-300 bg-white px-4 py-2 text-xs font-semibold text-neutral-700 hover:bg-neutral-50 disabled:opacity-60" data-testid="pending-cancel">
          {busy === "cancel" ? <Loader2 className="h-4 w-4 animate-spin" /> : <XCircle className="h-4 w-4" />}Annuler / changer de billet
        </button>
      </div>
    </div>
  );
}
